import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

const GenerateCouponsModal: React.FC<{ isOpen: boolean; onClose: () => void; onGenerate: (num: number) => void; }> = ({ isOpen, onClose, onGenerate }) => {
    const [couponCount, setCouponCount] = useState('');

    const handleGenerate = () => {
        const num = parseInt(couponCount, 10);
        if (isNaN(num) || num < 1 || num > 100) {
            toast("Please enter a number between 1 and 100", {
                autoClose: 3000, // Set the duration in milliseconds (3 seconds in this example)
                onClose: () => { },
            });

            return;
        }
        onGenerate(num);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <ModalBackdrop>
            <ModalContainer>
                <ModalHeader>
                    <h3>Generate Coupons</h3>
                </ModalHeader>
                <ModalBody>
                    <Input
                        type="number"
                        placeholder="Enter number (1-100)"
                        value={couponCount}
                        onChange={(e) => setCouponCount(e.target.value)}
                        min="1"
                        max="100"
                    />
                </ModalBody>
                <ModalFooter>
                    <GenerateButton onClick={handleGenerate}>Generate</GenerateButton>
                    <CancelButton onClick={onClose}>Close</CancelButton>
                </ModalFooter>
            </ModalContainer>
        </ModalBackdrop>
    );
};

export default GenerateCouponsModal;

// Styled components

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  margin-bottom: 15px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: calc(100% - 20px);
`;

const GenerateButton = styled.button`
  background-color: #28a745;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #218838;
  }
`;

const CancelButton = styled.button`
  background-color: #dc3545;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #c82333;
  }
`;
